import { Box, Container } from "@mui/material";
import PageHero from "../../components/PageHero";
import { useStyles } from "../Legal/styles";

const Disclaimer = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <PageHero colorScheme="light_blue" title="DISCLAIMER" />
      <Container className={classes.main}>
        <Box className={classes.mainHeading}>DISCLAIMER</Box>

        <Box className={classes.section}>
          <Box className={classes.sectionHeading}>
            This Website Is Informational, Impersonal and Not a Solicitation
          </Box>
          <Box className={classes.text}>
            No information on this website constitutes a promotion,
            recommendation, inducement, offer, or solicitation to (i) purchase
            or sell any securities or assets, (ii) transact any other business,
            or (iii) enter into any other legal transactions. All information
            provided by BITA on this website is informational, impersonal and
            not customized to the specific needs of any entity, person, or group
            of persons. BITA does not endorse, manage, promote, sell, or sponsor
            any investment fund or other vehicle that is offered by third
            parties and that seeks to provide an investment return linked to or
            based on the returns of any BITA index.
          </Box>
        </Box>

        <Box className={classes.section}>
          <Box className={classes.sectionHeading}>No Advisory Relationship</Box>
          <Box className={classes.text}>
            BITA is not an investment advisor, and BITA and its affiliates make
            no representation regarding the advisability of investing in any
            investment fund or other vehicle. This website should not be
            construed to provide advice of any kind, including, but not limited
            to, tax and legal.
          </Box>
        </Box>

        <Box className={classes.section}>
          <Box className={classes.text}>
            It is not possible to invest directly in an index. Index performance
            does not reflect the deduction of any fees or expenses. Past
            performance is not a guarantee of future returns. You should not
            make a decision to invest in any investment fund or other vehicle
            based on the statements set forth in this website, and are advised
            to make an investment in any investment fund or other vehicle only
            after carefully evaluating the risks associated with investment in
            the investment fund or other vehicle, as detailed in the offering
            memorandum or similar document prepared by or on behalf of the
            issuer. This website does not contain and does not purport to
            contain, the level of detail necessary to give sufficient basis to
            an investment decision. The addition, removal, or inclusion of a
            security in any BITA index is not a recommendation to buy, sell, or
            hold that security, nor is it investment advice.
          </Box>
        </Box>

        <Box className={classes.section}>
          <Box className={classes.sectionHeading}>No Warranties</Box>
          <Box className={classes.text}>
            The accuracy and/or completeness of any BITA index, any data
            included therein, or any data from which it is based is not
            guaranteed by BITA, and it shall have no liability for any errors,
            omissions, or interruptions therein. BITA makes no warranties,
            express or implied, as to results to be obtained from the use of
            information provided by BITA and used in this service, and BITA
            expressly disclaims all warranties of suitability with respect
            thereto.
          </Box>
        </Box>

        <Box className={classes.section}>
          <Box className={classes.sectionHeading}>Limitation of Liability</Box>
          <Box className={classes.text}>
            BITA shall not be liable for any claims or losses of any nature in
            connection with the use or misuse of the information in this
            website, including but not limited to, lost profits or punitive or
            consequential damages, even if BITA has been advised of the
            possibility of same.
          </Box>
        </Box>

        <Box className={classes.section}>
          <Box className={classes.sectionHeading}>Linked Products</Box>
          <Box className={classes.text}>
            BITA is compensated in retribution for licensing its indexes to
            third parties for the creation of investment funds or other
            vehicles. BITA is not responsible for the information provided by
            these parties or for anything that they provide.
          </Box>
        </Box>

        <Box className={classes.section}>
          <Box className={classes.sectionHeading}>Contact Us</Box>
          <Box className={classes.text}>
            If you have any comments, questions, please email us at{" "}
            <a href="mailto:info@bitadata.com">info@bitadata.com</a>. We will
            respond expeditiously.
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Disclaimer;
